<template>
	<v-container fluid>
		<v-card class="card-container mx-auto my-5" max-width="640">
			<v-app-bar class="my-2" dark color="rgb(0, 174, 141)">
				<v-toolbar-title>Tree View Chart</v-toolbar-title>
			</v-app-bar>
			<div style="width:100%; height:700px;" ref="tree" id="tree"></div>
		</v-card>
    </v-container>
</template>

<script>
 	import axios from 'axios';
    import constants from '@/assets/js/constants';
	import OrgChart from '@/assets/js/orgchart';
	export default {
		name: 'TrackingTree',
		data: function () {
			return {
				trackings: [],
				nodes: [],
			};
  		},

		methods: 
		{
			setTreeViewChart() 
			{
				var chart = new OrgChart(this.$refs.tree, 
				{
					enableSearch: true,
					mouseScrool: OrgChart.action.none,
					template: "trackingTemplate",
					nodeBinding: {
					field_0: "category",
					field_1: "referenceNumber",
					field_2: "createdDate",
					field_3: "createdBy",
					img_0: "img",
					field_4: "sendingEntity",
					field_5: "receivingEntity",
					field_6: "subject",
					field_7: "privacy",
					field_8: "priority",
					},
					menu: {
					pdf: { text: "Export PDF" },
					png: { text: "Export PNG" },
					svg: { text: "Export SVG" },
					csv: { text: "Export CSV" },
					json: { text: "Export JSON" },
					},
					anim: { func: OrgChart.anim.outBack, duration: 500 },
					nodes: this.nodes,
				});

				OrgChart.templates.trackingTemplate = Object.assign(
					{},
					OrgChart.templates.ana
				);

				OrgChart.templates.trackingTemplate.size = [350, 180];

				OrgChart.templates.trackingTemplate.minus =
					'<circle cx="15" cy="45" r="13" fill="#00ae8d" stroke="#00ae8d" stroke-width="1"></circle>' +
					'<line x1="8" y1="45" x2="22" y2="45" stroke-width="1" stroke="#ffffff"></line>';

				OrgChart.templates.trackingTemplate.plus =
					'<circle cx="15" cy="45" r="13" fill="#00ae8d" stroke="#00ae8d" stroke-width="1"></circle>' +
					'<line x1="8" y1="45" x2="22" y2="45" stroke-width="1" stroke="#ffffff"></line>' +
					'<line x1="15" y1="38" x2="15" y2="52" stroke-width="1" stroke="#ffffff"></line>';

				OrgChart.templates.trackingTemplate.field_0 =
					'<text style="font-size: 20px;" fill="#00ae8d" x="130" y="40" text-anchor="left">{val}</text>';
				OrgChart.templates.trackingTemplate.field_1 =
					'<text style="font-size: 20px;" fill="#737373" x="130" y="70" text-anchor="left">{val}</text>';

				OrgChart.templates.trackingTemplate.field_2 =
					'<text style="font-size: 18px;" fill="#b3bac5" x="130" y="120" text-anchor="left">Created Date&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{val}</text>';
				OrgChart.templates.trackingTemplate.field_3 =
					'<text style="font-size: 18px;" fill="#b3bac5" x="130" y="160" text-anchor="left">Created By&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{val}</text>';

				OrgChart.templates.trackingTemplate.node =
					'<rect x="0" y="0" height="10" width="100" fill="#00ae8d" stroke-width="2" stroke="#e9eef2"></rect>' +
					'<rect x="100" y="0" height="10" width="300" fill="#00ae8d" stroke-width="2" stroke="#e9eef2"></rect>' +
					'<rect class="box-node" x="0" y="10" height="200" width="100" fill="#ffffff" stroke-width="2" stroke="#e9eef2"></rect>' +
					'<rect x = "100" y = "10" width = "300" height = "200" fill = "#ffffff" stroke-width="2" stroke="#e9eef2" ></rect >';

				OrgChart.templates.trackingTemplate.menuButton =
					'<div style="position:absolute;right:{p}px;top:32px; width:25px;height:40px;cursor:pointer;" data-ctrl-menu="">' +
					'<hr style="background-color: #656565; height: 3px; border: none; margin: 6px 0px;">' +
					'<hr style="background-color: #656565; height: 3px; border: none; margin: 6px 0px;">' +
					'<hr style="background-color: #656565; height: 3px; border: none; margin: 6px 0px;">' +
					"</div>";
			},
			getTrackingData() 
			{
				axios.get(constants.ctsApiUrl + "Document/GetTrackingData?Id=8", {headers: constants.headers})
					.then((response) => 
					{
						console.log(response.data);
						this.trackings = response.data;
						this.setDataInNodes();
					}).catch((error) => console.log(error));
			},

			setDataInNodes() 
			{
				this.trackings.forEach((element) => 
				{
					let myTrackings = {};
					myTrackings.id = element.id;
					myTrackings.pid = element.parentId;
					myTrackings.category = element.category;
					myTrackings.referenceNumber = element.referenceNumber;
					myTrackings.createdDate = element.createdDate;
					myTrackings.createdBy = element.createdBy;
					myTrackings.sendingEntity = element.sendingEntity;
					myTrackings.receivingEntity = element.receivingEntity;
					myTrackings.subject = element.subject;
					myTrackings.privacy = element.privacy;
					myTrackings.priority = element.priority;
					// myTrackings.img = "https://cdn.balkan.app/shared/16.jpg"
					// console.log(myTrackings);
					this.nodes.push(myTrackings);
				});

				this.setTreeViewChart();
				// console.log(this.nodes)
			},
  		},

		mounted() 
		{
			this.getTrackingData();
		},
	}
</script>